import { PRESET_DAYS } from "@/pages/CreatorAnalytics/constants";
import type { DatePreset, IDateRange } from "@/pages/CreatorAnalytics/types";

export const getPresetRange = (preset: DatePreset): IDateRange => {
  const to = new Date();
  const from = new Date(to);
  const days = PRESET_DAYS[preset as Exclude<DatePreset, "custom">] ?? PRESET_DAYS["30d"];
  from.setDate(from.getDate() - days);
  return { from, to };
};
